'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.Menu = undefined;

var _Menu2 = require('./Menu');

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = require('../MenuItem');

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _Menu3.default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Menu/index.js
// module id = ./node_modules/material-ui/Menu/index.js
// module chunks = index